import {
  CheckEligibilityVendorEnum,
  EligibilityControllerApi,
} from "../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../utils/utils";

/**
 *
 * @author Atish Bagate
 */

interface CheckEligibilityParam {
  patientUuid: string;
  insuranceId: string;
  vendor: CheckEligibilityVendorEnum;
  providerId?: string;
}
export const useCheckEligibility = () =>
  useMutationWithLoading(async (param: CheckEligibilityParam) =>
    new EligibilityControllerApi(getConfigObject()).checkEligibility(
      param.patientUuid,
      param.insuranceId,
      param.vendor,
      param.providerId,
      getXtenantId()
    )
  );
